import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "Requesting a stop",
    paragraphs: ["Email the order reference and a clear cancellation request immediately. Do not include card details. A request can be completed only while payment handling and fulfilment work are still capable of being stopped."],
  },
  {
    title: "Before order acceptance",
    paragraphs: ["If payment has not been independently confirmed and the order has not been accepted, the order attempt can be closed. A temporary payment authorisation, if present, is released through the payment route's own processing rather than by the React return page."],
  },
  {
    title: "After acceptance",
    paragraphs: ["Customer service checks whether stock allocation, address processing and parcel preparation can still be reversed. If they can, cancellation is confirmed by email and any captured amount is initiated back through the original payment route. Provider posting occurs outside this storefront."],
  },
  {
    title: "When fulfilment cannot be stopped",
    paragraphs: ["Once the order has moved beyond a reversible stage, the cancellation request cannot be treated as a completed stop. A later product problem follows the Returns, Refunds & Exchanges process. Refusing a parcel does not create an automatic cancellation because the shipment and contents may still need to be identified and assessed."],
    links: [["Returns, Refunds & Exchanges", "/returns"]],
  },
  {
    title: "Merchant-side cancellation",
    paragraphs: ["The store may cancel before fulfilment where payment is not confirmed, required delivery information is unresolved, stock cannot be supplied or a reasonable fraud concern remains after review. The customer is told through the supplied email; captured sums for cancelled goods are returned through the original route."],
  },
  {
    title: "Rights preserved",
    paragraphs: ["Passing the operational stop point does not erase protection where the delivered goods prove dangerous, defective, broken, wrongly supplied or materially different from the listing. Any further entitlement that cannot lawfully be excluded also remains intact."],
  },
];

export default function OrderCancellation() {
  return <PolicyPage title="Order Cancellation Policy" intro="What happens when a customer asks to stop an order before fulfilment advances." sections={sections} related={[["Terms of Sale", "/terms-of-sale"], ["Payment, Pricing & Fraud", "/payment-pricing"]]} />;
}
